import seq from 'seq-logging';
import CONFIG from 'config';
import { LoggingQueueModel } from 'models/common.model';
import moment from 'moment';
import {
  LOGGING_LEVEL,
  LOG_PROPERTIES,
  LOG_STATE_PICK,
} from 'constants/logging.const';
import { pick } from 'lodash';
import { store } from 'store';

const logger = new seq.Logger({
  serverUrl: CONFIG.REACT_APP_SEQ_LOGGING_URL || '',
  apiKey: CONFIG.REACT_APP_SEQ_LOGGING_API_KEY || '',
  // eslint-disable-next-line no-console
  onError: (err) => console.log('>>> Error: ', err),
});

export const emitSeqLog = (data: Partial<LoggingQueueModel>) => {
  if (data) {
    const { transactionId } = store.getState()?.selfeApp;
    logger.emit({
      ...data,
      timestamp: moment().toDate(),
      level: data?.level || LOGGING_LEVEL.INFORMATION,
      messageTemplate: `[FE]: == ${transactionId} ==> | ${data?.messageTemplate}`,
      properties: {
        ...LOG_PROPERTIES,
        Environment: process.env.NODE_ENV,
        BoothId: store.getState()?.booth?.boothId,
        BoothCode: store.getState()?.booth?.boothInfo?.boothCode,
        AppState: pick(store.getState()?.selfeApp, LOG_STATE_PICK),
        ...data?.properties,
      },
    });
  }
};
